import React from "react";
import style from "./style";
import FakerProduts from "@/components/Fakes/products";
import FakerCommercialArea from "@/components/Fakes/commercial-area";

const FakeTvDetail = () => {
  return (
    <div className="container new-faker-tv-detail">
      <div className="skeleton new-faker-tv-detail--title" />
      <div className="new-faker-tv-detail--grid-container">
        <div className="skeleton new-faker-tv-detail--card" />
        <div className="skeleton new-faker-tv-detail--card" />
      </div>
      <div className="skeleton new-faker-tv-detail--title" />
      <div className="new-faker-tv-detail--grid-container-platafform">
        <div className="skeleton new-faker-tv-detail--plataform" />
        <div className="skeleton new-faker-tv-detail--plataform" />
        <div className="skeleton new-faker-tv-detail--plataform" />
        <div className="skeleton new-faker-tv-detail--plataform" />
      </div>
      <div className="skeleton new-faker-tv-detail--title" />
      <div className="new-faker-tv-detail--grid-container">
        <div className="skeleton new-faker-tv-detail--card" />
        <div className="skeleton new-faker-tv-detail--card" />
      </div>
      <style jsx>{style}</style>
    </div>
  );
};

export default FakeTvDetail;
